// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"3659b12e","184":"1f966c99","574":"d0221ff1","818":"1119da06","900":"815301c4","976":"c7f39186","996":"7ed18f59"}[chunkId] + ".chunk.js";
};